import { Assets, BitmapText, Container, Sprite } from "pixi.js";
import { IScene, Manager } from "../core/Manager";
import { Reels } from "../reels/Reels";
// import { setSpinResponseDataGlobal } from "../config/GlobalVariableConfig";
import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { currentBackgorundMusic, globalScreen, RespinIndex, willBannerAutoProceedGlobal } from "../config/GlobalVariableConfig";
import { spinData } from "../server/getServerResposesFun";
// import { Banner } from "./Banner";
import { BigWin } from "./BigWin";
import { GameScene } from "./GameScene";


import { sound } from "@pixi/sound";
import { Group, Tween } from "tweedle.js";
import { reelSpinEmitter } from "../reels/Reels";

const tweenGroup: Group = new Group();


export class FreeGameScene extends Container implements IScene {

    // Asset bundles
    assetBundles: string[] = ["game-screen", "sound", "intro-screen", "big-win"];

    // Containers
    private background = new Container();
    private reelFrame = new Container();


    private backgroundImageCont = new Container();
    private logo: Spine | null = null;
    private reelBackSpine: Spine | null = null;

    private winMeterstate: number = 0;
    private winMeterSpine: Spine | null = null;

    private backgroundSpine: Spine | null = null;

    private winMult = new Container();
    private currentMultVal: number = 0;
    private winMultFx: Spine | null = null;
    private winMultText: BitmapText | null = null;

    private reels: Reels | null = null;
    // private banner: Banner | null = null;
    private bigWin: BigWin | null = null;

    // private backgroundMusic: Sound | null = null;

    private numberOfFS: number;
    private baseGameWin: number;
    private totalFGSessionWin: number; // this is total win including base spin

    private firstSpin: boolean = true;

    private numberOfFSPlayed: number = 0;

    private autoTriggerTimeout: ReturnType<typeof setTimeout>;


    private boundUpdateMultiplier: () => void;
    private boundUpdateSurgeMeter: () => void;
    private boundShakeEffect: () => void;

    private pointerDownHandlerFree: () => void;

    constructor(numberOfFS: number, baseGameWin: number) {
        super();
        this.numberOfFS = numberOfFS;
        this.numberOfFSPlayed = 0;
        this.baseGameWin = baseGameWin;


        this.totalFGSessionWin = baseGameWin;

        this.firstSpin = true;


        this.boundUpdateMultiplier = this.updateMultiplier.bind(this);
        this.boundUpdateSurgeMeter = this.updateSurgeMeter.bind(this);
        this.boundShakeEffect = this.shakeEffect.bind(this);

        this.pointerDownHandlerFree = this.onBannerPointerDown.bind(this);


        reelSpinEmitter.on('updateMultiplier', this.boundUpdateMultiplier);
        reelSpinEmitter.on('updateSurgeMeter', this.boundUpdateSurgeMeter);
        reelSpinEmitter.on('shakeEffect', this.boundShakeEffect);
    }


    override  destroy() {

        reelSpinEmitter.off('updateMultiplier', this.boundUpdateMultiplier);
        reelSpinEmitter.off('updateSurgeMeter', this.boundUpdateSurgeMeter);
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        Assets.unload(['freeBackgroundSkel', 'freeBackgroundAtlas']);
        super.destroy();
    }

    private shakeEffect() {

        console.log("inside shakeEffect");

        let duration = 250;
        let intensity = 20;

        const original = { x: this.x, y: this.y };
        const offset = { x: 0, y: 0 };

        const tween = new Tween(offset, tweenGroup)
            .to({ x: 0, y: 0 }, duration)
            .onUpdate(() => {
                this.x = original.x + (Math.random() - 0.5) * intensity;
                this.y = original.y + (Math.random() - 0.5) * intensity;
            })
            .onComplete(() => {
                this.x = original.x;
                this.y = original.y;
                tweenGroup.remove(tween);
            })
            .start();
    }


    public async constructorWithAssets(): Promise<void> {

        this.setupBackground();

        this.setupLogo();

        this.setupWinMult();

        this.reels = new Reels();
        this.background.addChild(this.reels);
        this.reels.position.set(614, 572);
        this.reels.alpha = 0;

        this.setupReelFrame();


        this.bigWin = new BigWin(Manager.screenwidth, Manager.screenHeight);
        this.bigWin.position.set(Manager.screenwidth / 2, Manager.screenHeight / 2);
        this.addChild(this.bigWin);


        // await this.bigWin.bigWinFunction(500);

        // this.freeSpinPlay();

        // this.banner = new Banner(Manager.screenwidth, Manager.screenHeight);
        // this.addChild(this.banner);


        this.updateMultiplier(0);
        this.updateSurgeMeter(0);

        // reset the multiplier value in starting of free games
        // this.reels.multTotalValue.text = "";

        this.resize(Manager.screenwidth, Manager.screenHeight);


    }

    private updateMultiplier(multVal: number): void {

        console.log("reelSpinEmitter:updateReelMult", multVal)

        if (multVal == 0) {
            this.winMultText.text = `X1`
        }
        else if (multVal > 0) {

            this.winMultText.text = `X${multVal}`

            if (multVal > this.currentMultVal) {

                let scaleVal = 1.10;
                if (multVal - this.currentMultVal > 1) {
                    //meaning swril multiplier
                    scaleVal = 1.45;
                }

                const tweenBreath = new Tween(this.winMultText.scale, tweenGroup)
                    .to({ x: scaleVal, y: scaleVal }, 150) // Scale up
                    .yoyo(true) // Automatically reverses the tween
                    // .repeat(1) // Infinite loop
                    .onComplete(() => {
                        tweenGroup.remove(tweenBreath);
                        this.winMultText.scale = 1;
                    })
                    .start();

                this.winMultFx.state.setAnimation(0, "animation", false);
                sound.play("Meter_Section_Fills", { volume: 0.2 });
            }
        }

        this.currentMultVal = multVal;

        // this.shakeEffect();
    }

    private updateSurgeMeter(meterVal: number): void {
        // cap the meterVal
        meterVal = (meterVal > 5) ? 5 : meterVal

        console.log("freeGamescene:reelSpinEmitter:updateSurgeMeter", meterVal, this.winMeterstate);

        if (meterVal == 0 && this.winMeterstate > 0) {

            let currentMeterState = this.winMeterstate;
            this.winMeterstate = 0;
            this.winMeterSpine.state.setAnimation(0, `reset_${currentMeterState}`, false).listener = {
                complete: () => {
                    this.winMeterSpine.state.clearListeners();
                    this.winMeterstate = meterVal;
                }
            }
        }
        else if (meterVal > 0 && meterVal == this.winMeterstate + 1) { // meterVal > this.winMeterstate was not correct 
            this.winMeterstate = meterVal;

            if (meterVal == 5) {
                sound.play("Meter_Gets_Full", { volume: 0.5 });
            }
            else {
                sound.play("Multiplier_Update", { volume: 0.2 });
            }

            this.winMeterSpine.state.setAnimation(0, `fill_${meterVal}`, false).listener = {
                complete: () => {
                    this.winMeterSpine.state.setAnimation(0, `idle_${meterVal}`, true);
                    this.winMeterSpine.state.clearListeners();
                }
            }
        }
    }

    private setupWinMult() {


        // private winMult = new Container();
        // private winMultFx: Spine | null = null;
        // private winMultText: BitmapText | null = null;

        this.winMult.alpha = 0;
        this.background.addChild(this.winMult);

        const multBase = Sprite.from('multiplier_base');
        multBase.anchor = 0.5;
        this.winMult.addChild(multBase);


        this.winMultFx = Spine.from({
            skeleton: "multFxSkel",
            atlas: "multFxAtlas",
        });
        this.winMultFx.scale = 1.5;
        this.winMult.addChild(this.winMultFx);
        // this.winMultFx.state.setAnimation(0, "animation", true);

        this.winMultText = new BitmapText({
            text: "X1",
            style: {
                fontFamily: 'sugar_multiplier',
                fontSize: 120
            }
        });
        this.winMultText.anchor = 0.5;
        this.winMultText.position.set(0, -15);
        this.winMult.addChild(this.winMultText);

    }

    private callExitFreeGameAuto() {

        this.autoTriggerTimeout = setTimeout(() => {
            clearTimeout(this.autoTriggerTimeout);
            console.log("calling freeGameSceneChnage exitFreeGame pointerdown auto")
            this.exitFreeGame();
        }, 10000); // 10 seconds
    }

    private onBannerPointerDown(): void {
        clearTimeout(this.autoTriggerTimeout);
        console.log("calling freeGameSceneChnage exitFreeGame pointerdown")

        this.exitFreeGame();

        Manager.banner.bgContainer.off('pointerdown', this.pointerDownHandlerFree);

    }


    public async freeSpinPlay() {


        // Manager.banner.bgContainer.once('pointerdown', () => {

        //     clearTimeout(this.autoTriggerTimeout);
        //     console.log("calling freeGameSceneChnage exitFreeGame pointerdown")

        //     this.exitFreeGame();
        // });


        // this.updateMultiplier(0);
        // this.updateSurgeMeter(0);


        // casinoChannel.publish('featureRoundStarted', { uistate: 'freespins', gameMode: 'fs_' });
        // Manager.casinoChannelHandler.reportFeatureRoundStarted();

        console.log("casinoChannel-featureRoundStarted")
        // casinoChannel.publish('updateFeatureCounter', { counterValue: 111 });
        // casinoChannel.publish('updateFeatureTotalWin', { totalWinAmount: `${(99)}` });

        // casinoChannel.publish('updateFeatureCounter', { counterValue: this.numberOfFS });
        // Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS)

        console.log("this.numberOfFS", this.numberOfFS);


        console.log("casinoChannel-updateFeatureCounter")

        // this.ui?.resetWinValue();

        const fsRevealIndexes = spinData.respins
            .map((respin, index) => (respin.type === "fs_reveal" ? index : -1))
            .filter(index => index !== -1);

        console.log("fsRevealIndexes", fsRevealIndexes);

        let freeGameTrigger = 1;
        let winAmount: number;
        let accumulatedsWinAmount: number;

        while (freeGameTrigger != -1 && freeGameTrigger != -2) {

            // this.ui.setFreeGameCounter(totalFreeGame, totalFreeGame - freeSpinRemaining + 1);
            //update counter here

            this.updateSurgeMeter(0);

            Manager.casinoChannelHandler.reportFeatureRoundStarted();


            if (this.firstSpin) // first time counter appear
            {
                this.firstSpin = false;
                Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);
                Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((this.baseGameWin * 100).toFixed(0));
                await new Promise(resolve => setTimeout(resolve, 500));
            }

            this.numberOfFS = this.numberOfFS - 1;
            if (this.numberOfFS >= 0) {
                Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);
                this.numberOfFSPlayed = this.numberOfFSPlayed + 1;
            }

            [freeGameTrigger, winAmount, accumulatedsWinAmount] = await this.spinReel();

            console.log("Freegame while loop", freeGameTrigger, winAmount, RespinIndex.value);

            if (winAmount > 0 && freeGameTrigger != -1) {
                await this.bigWin.bigWinFunction(winAmount);
            }

            Manager.casinoChannelHandler.reportFeatureRoundCompleted((winAmount * 100).toFixed(0));

            const featureWinCentsNum = Math.floor(winAmount * 100);
            console.log("reportUpdateFeatureTotalWin", featureWinCentsNum);

            Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((accumulatedsWinAmount * 100).toFixed(0));

            if (winAmount > 0) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }

            if (freeGameTrigger == -1 || freeGameTrigger == -2) {
                this.totalFGSessionWin = accumulatedsWinAmount;
            }



        }

        console.log("Freegame while loop exit");

        if (Manager.banner) {
            Manager.casinoChannelHandler.reportFeatureExit();
            await Manager.banner.appearFreeGameOutroBanner(this.totalFGSessionWin, this.numberOfFSPlayed);

            if (freeGameTrigger === -2) { // max win reached

                await new Promise(resolve => setTimeout(resolve, 500));
                Manager.casinoChannelHandler.reportMaxWin();
                // await this.waitForDialogOk();
            }

            Manager.banner.bgContainer.on('pointerdown', this.pointerDownHandlerFree);

            if (willBannerAutoProceedGlobal) {
                this.callExitFreeGameAuto();
            }

            console.log("appearFreeGameOutroBanner");

            const game = new GameScene();
            await Manager.changeScene(game, false);

        }


    }

    private async exitFreeGame() {
        // Manager.casinoChannelHandler.reportFeatureExit();

        currentBackgorundMusic.stop();

        console.log("casinoChannel-featureExit");

        // this.backgroundMusic?.stop();
        await Manager.banner?.disappearBanner(false);



        // reportGameRoundCompleted();
        Manager.casinoChannelHandler.reportGameRoundCompleted();

    }

    private async spinReel(): Promise<[number, number, number]> {

        let freeGameTrigger = 0;
        let winAmount = 0;
        let accumulatedsWinAmount = 0;

        if (this.reels) {

            [freeGameTrigger, winAmount, accumulatedsWinAmount] = await this.reels.startPlay("FREEGAME");

            console.log("freeGameTrigger", freeGameTrigger);
            console.log("winAmount", winAmount);

        }

        return [freeGameTrigger, winAmount, accumulatedsWinAmount];

    }


    private setupBackground(): void {

        this.backgroundImageCont.addChild(Sprite.from('backgroundFree'));
        this.addChild(this.backgroundImageCont);


        // this.background.addChild(Sprite.from('baseReels'));

        this.backgroundSpine = Spine.from({
            skeleton: "freeBackgroundSkel",
            atlas: "freeBackgroundAtlas",
        });

        this.backgroundSpine.position.set(globalScreen / 2, globalScreen / 2);

        // spineSymbol.scale=0.1;

        this.backgroundSpine.state.setAnimation(0, "animation", true);
        // spineSymbol.state.setAnimation(0, "win", true);
        this.background.addChild(this.backgroundSpine);

        this.addChild(this.background);


    }

    private setupLogo(): void {

        this.logo = Spine.from({
            skeleton: "logoSkel",
            atlas: "logoAtlas",
        });

        this.logo.alpha = 0;

        this.background.addChild(this.logo);
        this.logo.state.setAnimation(0, "animation", true);

    }

    private setupReelFrame(): void {


        const reelBackSlidesSpine = Spine.from({
            skeleton: "reelBackSliderSkel",
            atlas: "reelBackSliderAtlas"
        })
        reelBackSlidesSpine.position.set(globalScreen / 2, 324);
        reelBackSlidesSpine.alpha = 0;
        this.background.addChild(reelBackSlidesSpine);

        this.reelBackSpine = Spine.from({
            skeleton: "reelBackSkel",
            atlas: "reelBackAtlas"
        })

        this.reelFrame.addChild(this.reelBackSpine);


        this.background.addChild(this.reelFrame);
        this.reelFrame.position.set(globalScreen / 2, globalScreen / 2);


        this.winMeterSpine = Spine.from({
            skeleton: "meterSkel",
            atlas: "meterAtlas"
        })

        this.winMeterSpine.state.setAnimation(0, "appear", false);
        this.background.addChild(this.winMeterSpine);

        //put reel on top
        this.background.addChild(this.reels);
        this.background.addChild(this.logo);
        this.background.addChild(this.winMult);


        this.reels.alpha = 1;
        this.logo.alpha = 1;
        this.winMult.alpha = 1;

        this.reelBackSpine.state.setAnimation(0, "freegame_idle", true);

        reelBackSlidesSpine.alpha = 1;
        reelBackSlidesSpine.state.setAnimation(0, "freegame_idle", true);

    }



    public update(): void {
        tweenGroup.update();

        this.reels?.update();
        // this.banner?.update();
        this.bigWin?.update();
    }

    public resize(screenWidth: number, screenHeight: number): void {

        // this.screenWidth = screenWidth;
        // this.screenHeight = screenHeight;

        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / globalScreen, screenHeight / globalScreen);


        if (screenWidth > screenHeight) {
            scale = Math.min(screenWidth / 1920, screenHeight / 1080);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.background.scale.set(scale, scale);

            const xPos = (globalScreen * scale - screenWidth) / 2;
            const yPos = (globalScreen * scale - screenHeight) / 2;

            this.background.x = -xPos;
            this.background.y = -yPos;

            this.logo.scale = 1;
            this.logo.position.set(284, 724);

            this.winMult.scale = 1;
            this.winMult.position.set(284, globalScreen / 2);

            if (this.winMeterSpine) {
                this.winMeterSpine.rotation = 0;
                this.winMeterSpine.position.set(1544, 959);
            }


            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (globalScreen * bgScale - screenWidth) / 2;
            const bgYPos = (globalScreen * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);

        }
        else {
            scale = 1.22 * Math.min(screenWidth / 1080, screenHeight / 1920);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.background.scale.set(scale, scale);

            const xPos = (globalScreen * scale - screenWidth) / 2;
            const yPos = (globalScreen * scale - screenHeight) / 2;

            this.background.x = -xPos;
            this.background.y = -yPos;

            this.logo.scale = .75;
            this.logo.position.set(globalScreen / 2, 384);

            this.winMult.scale = .8;
            this.winMult.position.set(1314, 444);


            if (this.winMeterSpine) {
                this.winMeterSpine.rotation = Math.PI / 2;
                this.winMeterSpine.position.set(globalScreen / 2, 1444);
            }

            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (globalScreen * bgScale - screenWidth) / 2;
            const bgYPos = (globalScreen * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);

        }


        this.bigWin?.scale.set(scale, scale);
        this.bigWin?.position.set(screenWidth / 2, screenHeight / 2);
        this.bigWin?.resize(screenWidth, screenHeight);

        // this.banner?.resize(screenWidth, screenHeight);

    }



}
